export const Browsers = {
  GoogleChrome: 'Google Chrome',
  MicrosoftEdge: 'Microsoft Edge',
  MozillaFirefox: 'Mozilla Firefox',
  Other: 'Other',
  Safari: 'Safari'
};

export const Devices = {
  WindowsComputer: 'Windows Computer',
  MacComputer: 'Mac Computer',
  AndroidSmartphone: 'Android Smartphone',
  AndroidTablet: 'Android Tablet',
  iPhone: 'iPhone',
  iPad: 'iPad',
  Other: 'Other'
};
